import { Spin, Typography, Card } from 'antd';
import {
	UserOutlined,
	GlobalOutlined,
	LoadingOutlined,
	InfoCircleOutlined,
} from '@ant-design/icons';
import AddTimeZone from '@/pages/ReceptionistDashboard/Overview/ManageNotifications/components/AddTimeZone';

const { Text, Title, Paragraph } = Typography;

const GeneralSettings: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
	return (
		<div className="p-8 max-w-5xl mx-auto">
			<div className="mb-8">
				<div className="flex items-center justify-between">
					<div className="flex items-center">
						<div className="bg-blue-50 p-3 rounded-lg mr-4">
							<UserOutlined className="text-2xl text-blue-500" />
						</div>
						<div>
							<Title level={2} className="!mb-0">
								General Settings
							</Title>
							<Text type="secondary">Manage your general settings</Text>
						</div>
					</div>
				</div>
			</div>

			<Spin spinning={isLoading} indicator={<LoadingOutlined style={{ fontSize: '48px' }} spin />}>
				<div className="grid gap-6">
					{/* Time Zone Card */}
					<Card
						className="shadow-sm hover:shadow-md transition-shadow duration-300"
						title={
							<div className="flex items-center">
								<GlobalOutlined className="text-blue-500 mr-2" />
								<span>Time Zone Settings</span>
							</div>
						}
					>
						<div className="space-y-4">
							<Paragraph type="secondary" className="mb-6">
								Select your preferred time zone. This will be used for all date and time displays
								across the application.
							</Paragraph>

							<div className="bg-gray-50 p-4 rounded-lg w-full">
								<AddTimeZone />
							</div>

							<div className="mt-4 p-3 bg-blue-50 rounded-lg">
								<Text type="secondary" className="text-sm">
									<InfoCircleOutlined className="mr-2" />
									Your current time zone will be used for all notifications and scheduled activities
								</Text>
							</div>
						</div>
					</Card>
				</div>
			</Spin>
		</div>
	);
};

export default GeneralSettings;
